const END_OF_CENTRAL_DIRECTORY = 0x06054b50;
const ZIP64_END_OF_CENTRAL_DIRECTORY = 0x06064b50;
const ZIP64_LOCATOR = 0x07064b50;
const CENTRAL_DIRECTORY_ENTRY = 0x02014b50;

const ZIP64_MARKER = 0xffffffff;

async function bytesOf(blob, start, length) {
    return new DataView(await blob.slice(start, start + length).arrayBuffer());
}

async function readZip64EndOfCentralDirectory(blob, trailer, trailerOffset) {
    const locatorOffset = trailerOffset - 20;

    if (locatorOffset < 0 || trailer.getUint32(locatorOffset, true) !== ZIP64_LOCATOR) {
        return null;
    }

    const header = await bytesOf(blob, Number(trailer.getBigUint64(locatorOffset + 8, true)), 56);

    if (header.getUint32(0, true) !== ZIP64_END_OF_CENTRAL_DIRECTORY) {
        return null;
    }

    return {
        entryCount: Number(header.getBigUint64(32, true)),
        directorySize: Number(header.getBigUint64(40, true)),
        directoryOffset: Number(header.getBigUint64(48, true)),
    };
}

async function readEndOfCentralDirectory(blob) {
    // The trailer is 22 bytes plus a comment of at most 65535.
    const length = Math.min(blob.size, 22 + 65535);
    const trailer = await bytesOf(blob, blob.size - length, length);

    for (let offset = trailer.byteLength - 22; offset >= 0; offset--) {
        if (trailer.getUint32(offset, true) !== END_OF_CENTRAL_DIRECTORY) {
            continue;
        }

        const directory = {
            entryCount: trailer.getUint16(offset + 10, true),
            directorySize: trailer.getUint32(offset + 12, true),
            directoryOffset: trailer.getUint32(offset + 16, true),
        };

        if (directory.directoryOffset !== ZIP64_MARKER && directory.entryCount !== 0xffff) {
            return directory;
        }

        return await readZip64EndOfCentralDirectory(blob, trailer, offset) ?? directory;
    }

    throw new Error('archive illisible : fin de répertoire central introuvable');
}

// Entry names of a zip, read from its central directory alone: a few hundred KB at the end of the
// file whatever its size, so a delivery is checked before a single chunk is uploaded. The same
// reading as list() in scripts/support/zip.js, on a Blob instead of a file descriptor.
async function archiveEntries(blob) {
    const { entryCount, directorySize, directoryOffset } = await readEndOfCentralDirectory(blob);
    const directory = await bytesOf(blob, directoryOffset, directorySize);
    const decoder = new TextDecoder('utf-8');
    const names = [];

    for (let offset = 0; names.length < entryCount && offset + 46 <= directory.byteLength;) {
        if (directory.getUint32(offset, true) !== CENTRAL_DIRECTORY_ENTRY) {
            break;
        }

        const nameLength = directory.getUint16(offset + 28, true);
        const extraLength = directory.getUint16(offset + 30, true);
        const commentLength = directory.getUint16(offset + 32, true);

        names.push(decoder.decode(new Uint8Array(directory.buffer, directory.byteOffset + offset + 46, nameLength)));

        offset += 46 + nameLength + extraLength + commentLength;
    }

    return names;
}

module.exports = { archiveEntries };
